import httpRequest from "@/core/http-request";

//字典分类API
export const dictionaryTypeApi = {
  saveDictType(data) {
    return httpRequest.post("/dict-type/save", data);
  },
  pageDictType(condition) {
    return httpRequest.get("/dict-type/page", { params: condition });
  },
  listDictType() {
    return httpRequest.get("/dict-type/list");
  },
  deleteDicType(ids) {
    return httpRequest.post("/dict-type/delete", ids);
  }
};
